<template>
    <div class="editables-controls">
        <Button
            v-if="isSettingsPaneVisible && !showSettingsPaneInModal"
            class="campaign-edit__header-action-btn"
            size="small"
            icon="md-arrow-back"
            @click="hideSettingsPane"
        >
            Back
        </Button>
        <Button class="campaign-edit__header-action-btn" size="small" @click="toggleExpand">
            {{ allExpanded ? "Collapse All" : "Expand All" }}
        </Button>
        <Button
            v-if="showDetachBtn"
            class="campaign-edit__header-action-btn detach-btn"
            size="small"
            icon="md-swap"
            @click="detach"
        />
        <Input
            class="campaign-edit__header-action-btn editables-controls__search"
            :model-value="searchValue"
            size="small"
            search
            placeholder="Search"
            clearable
            @onChange="setSearchValue"
        />
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import { EditorAction, EditorGetters } from "@/store/modules/editor";

export default defineComponent({
    name: "EditablesListControls",
    props: {
        allExpanded: {
            type: Boolean
        },
        searchValue: {
            type: String,
            default: ""
        }
    },

    emits: ["detach", "update:search-value", "update:all-expanded"],

    computed: {
        isSettingsPaneVisible() {
            return this.$store.state.editor.isSettingsPaneVisible;
        },

        selectedEditables() {
            return this.$store.getters[EditorGetters.selectedEditables];
        },

        showDetachBtn() {
            return !this.showEditablesPaneInModal;
        },

        showEditablesPaneInModal() {
            return this.$store.state.editor.showEditablesPaneInModal;
        },

        showSettingsPaneInModal() {
            return this.$store.state.editor.showSettingsPaneInModal;
        }
    },

    watch: {
        selectedEditables() {
            this.resetSearchValue();
        }
    },

    methods: {
        detach() {
            this.$emit("detach");
        },

        hideSettingsPane() {
            this.$store.dispatch(EditorAction.SetEditedEditable, null);
        },

        setSearchValue(event: Event) {
            const value = (event.target as HTMLInputElement).value;
            this.$emit("update:search-value", value);
        },

        resetSearchValue() {
            this.$emit("update:search-value", "");
        },

        toggleExpand() {
            this.$emit("update:all-expanded", !this.allExpanded);
        }
    }
});
</script>

<style lang="scss">
@use "@style/variables" as *;

.editables-controls {
    position: relative;
    top: 0;
    left: 0;
    height: 63px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    border-bottom: $cmp-dark-border-width solid $cmp-dark-border-color;

    &__search {
        background-color: transparent;
        border: none;

        &:hover {
            background-color: transparent;
            border: none;
        }
    }

    .campaign-edit__header-action-btn {
        margin-left: $spacing-small;
        margin-bottom: $spacing-small;
        font-size: 12px;

        > span {
            display: inline;
        }

        &.detach-btn {
            justify-self: flex-end;
        }
    }
}
</style>
